// Utility functions for journal entry locking

/**
 * Fields that can always be edited, even when entry is locked
 */
const ALWAYS_EDITABLE_FIELDS = [
    // Mood fields (day1Mood through day14Mood)
    'day1Mood', 'day2Mood', 'day3Mood', 'day4Mood', 'day5Mood', 'day6Mood', 'day7Mood',
    'day8Mood', 'day9Mood', 'day10Mood', 'day11Mood', 'day12Mood', 'day13Mood', 'day14Mood',
    // Notes fields
    'progressNotes', 'notes', 'reflectionNotes', 'additionalNotes'
];

/**
 * Check if a field should be disabled based on lock status
 * @param {string} fieldName - The name of the field to check
 * @param {boolean} isLocked - Whether the entry is locked
 * @returns {boolean} - Whether the field should be disabled
 */
export const isFieldDisabled = (fieldName, isLocked) => {
    // if (!isLocked) return false;
    //
    // // Mood and notes fields can always be edited
    // return !ALWAYS_EDITABLE_FIELDS.includes(fieldName);

    // Temporarily disable frontend lock enforcement.
    return false;
};

/**
 * Check if a field can be edited even when locked
 * @param {string} fieldName - The name of the field to check
 * @returns {boolean} - Whether the field is always editable
 */
export const isAlwaysEditable = (fieldName) => {
    return ALWAYS_EDITABLE_FIELDS.includes(fieldName);
};

/**
 * Get list of all mood field names
 * @returns {string[]} - Array of mood field names
 */
export const getMoodFields = () => {
    return [
        'day1Mood', 'day2Mood', 'day3Mood', 'day4Mood', 'day5Mood', 'day6Mood', 'day7Mood',
        'day8Mood', 'day9Mood', 'day10Mood', 'day11Mood', 'day12Mood', 'day13Mood', 'day14Mood'
    ];
};

/**
 * Get list of all notes field names
 * @returns {string[]} - Array of notes field names
 */
export const getNotesFields = () => {
    return ['progressNotes', 'notes', 'reflectionNotes', 'additionalNotes'];
};
